<template>
  <div
    class="
      negative-margined
      relative
      flex flex-col
      gap-4
      bg-default-green-10
      px-4
      pb-10
      pt-8
    "
  >
    <div class="padded">
      <h2 class="hyppo-bold md:elephant-bold text-black-main mb-4 text-center">
        {{ $t("magazine.search.title") }}
      </h2>
      <div class="flex flex-col gap-4 md:flex-row md:items-center">
        <SkeletonAnimatedPlaceholder
          height="47px"
          width="100%"
          borderRadius="30px"
          class="md:flex-1"
        />
        <SkeletonAnimatedPlaceholder
          height="47px"
          width="190px"
          borderRadius="30px"
          class="mx-auto"
        />
      </div>
    </div>
  </div>
</template>
